export default () => ({
  root: {
    borderRadius: 14,
    overflow: 'hidden',
  },
});
